export default "__VITE_ASSET__CWMecoys__"